export const environment = {
  production: true,
  apiUrl: 'https://dev-api.mapavyuky.cz',
};
